import React from 'react';
import { Navigation } from './components/Navigation';
import { HeroSection } from './components/HeroSection';
import { EssenceSection } from './components/EssenceSection';
import { GallerySection } from './components/GallerySection';
import { SalesSection } from './components/SalesSection';
import { StaySection } from './components/StaySection';
import { LocationSection } from './components/LocationSection';
import { ContactSection } from './components/ContactSection';
import { Footer } from './components/Footer';
import { LanguageProvider } from './contexts/LanguageContext';
export function App() {
  return <LanguageProvider data-id="element-0">
      <div className="min-h-screen bg-charcoal-900 text-cream font-body selection:bg-gold selection:text-charcoal-900" data-id="element-1">
        <Navigation data-id="element-2" />

        <main data-id="element-3">
          <HeroSection data-id="element-4" />
          <EssenceSection data-id="element-5" />
          <GallerySection data-id="element-6" />
          <SalesSection data-id="element-7" />
          <StaySection data-id="element-8" />
          <LocationSection data-id="element-9" />
          <ContactSection data-id="element-10" />
        </main>

        <Footer data-id="element-11" />
      </div>
    </LanguageProvider>;
}